import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import {
    Alert, Box, Button, CircularProgress, Container, Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Paper, Select, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination,
    TableRow, Toolbar, Typography
} from '@mui/material';

import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import UndoIcon from '@mui/icons-material/Undo';

import { NavbarInicio } from '../ui/NavbarInicio';

import { usePages } from '../../hooks/usePages';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { Materias } from '../../actions/catalogos/materiaActions';
import { ActualizarMateriaDistrito, AgregarMateriaDistrito, MateriaDistritos } from '../../actions/catalogos/materiaDistritoActions';

import { usePermisos } from '../../hooks/usePermisos';

import { ObtenerDistritosJudiciales } from '../../actions/catalogos/distritoJudicialActions';
import { NotFoundScreen } from '../auth/NotFoundScreen';
    
export const MateriaDistritoScreen = ( ) => {

    const { tipoUsuario, loading } = usePermisos();

    const navigate = useNavigate();

    const [errors, setErrors] = useState({ });

    const [rows, setRows] = useState( [ ] );

    const [distrito, setDistrito] = useState( 0 );
    const [distritoArray, setDistritoArray] = useState( [ ] );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState( [ ] );

    const [idReferencia, setIdReferencia] = useState( '' );
    const [opcion, setOpcion] = useState( '' );

    const [loadingTable, setLoadingTable] = useState( true );
    const [loadingSave, setLoadingSave] = useState( false );
    const [openModal, setOpenModal] = useState( false );
  
    const [page, rowsPerPage, handleChangePage, handleChangeRowsPerPage] = usePages();
  
    const handleChangeSwitch = ( id, value ) => {

        const newRows = rows.map( (row) => { if(row.idMateriaDistrito === id){ row.activo = value; return row; } else{ return row; } } );
        setRows( newRows );        

        const materiaDistrito = rows.filter( function(row){ return row.idMateriaDistrito === id; } );
        cambiarEstatus( materiaDistrito[0] );
    }

    const handleOpenModal = () => {
        setOpenModal(true);
    }

    const handleCloseModal = () => {

        setDistrito( 0 );
        setMateria( 0 );

        setOpenModal(false);
        setErrors( { } );
    }

    const cambiarEstatus = async ( { idMateriaDistrito, activo,  materia, distritoJudicial } ) => {

        const params = {
            idMateriaDistrito,
            idDistritoJudicial: distritoJudicial.idDistritoJudicial,
            idMateria: materia.idMateria,
            activo,
        };

        await ActualizarMateriaDistrito( params );
    }

    const AgregarRegistro = () => {

        setOpcion( 'agregar' );
        setIdReferencia( 0 );

        handleOpenModal();
    }

    const EditarRegistro = ( id, idDistrito , idMateria ) => {
        
        setDistrito( idDistrito );
        setMateria( idMateria );

        setOpcion( 'editar' );
        setIdReferencia( id );

        handleOpenModal();
    }

    const Guardar = async () => {

        const valid = validateFiels();

        if( !valid ){
            return false;
        }

        setLoadingSave( true );

        const validate = validateDuplicidad();
        if( !validate ) return;

        if( opcion === 'agregar' ){
            const params = {
                idMateriaDistrito: 0,
                idDistritoJudicial: distrito,
                idMateria: materia,
                activo: true,
            };

          

            await AgregarMateriaDistrito( params ).then( response => {
                if( response ){
                    if( response.status === 200){
                        if( response.data ){
                            
                            setTimeout(() => {
                                
                                setRows([ 
                                    ...rows,  
                                    {
                                        idMateriaDistrito: response.data.idMateriaDistrito,
                                        idDistritoJudicial: response.data.idDistritoJudicial,
                                        distritoJudicial: response.data.distritoJudicial,
                                        idMateria: response.data.idMateria,
                                        materia: response.data.materia,

                                        activo: true
                                    }
                                ]);  
    
                                handleCloseModal();

                                setLoadingSave( false );

                            }, 1000);                            
                            
                        } 
                    }
                }
            });
        }

        if( opcion === 'editar' ){
            const materiaDistrito = rows.filter( function(row){ return row.idMateriaDistrito === idReferencia; } )[0];

            const params = {
                idMateriaDistrito: idReferencia,
                idDistritoJudicial: distrito,
                idMateria: materia,
                activo: materiaDistrito.activo,
            };
            
            await ActualizarMateriaDistrito( params ).then( response => {
                if( response ){
                    if( response.status === 200){

                        setTimeout(() => {
                                
                            const newRows = rows.map( (row) => { 
                                if(row.idMateriaDistrito === idReferencia){ 
                                    row.idDistritoJudicial = response.data.idDistritoJudicial;
                                    row.distritoJudicial = response.data.distritoJudicial;
                                    row.idMateria = response.data.idMateria;
                                    row.materia = response.data.materia;
                                    return row; 
                                } 
                                else{ 
                                    return row; 
                                } 
                            });
    
                            setRows( newRows ); 
                            
                            handleCloseModal();

                            setLoadingSave( false );

                        }, 1000);                        
                        
                    }
                }                
            });
        }
    }

    const validateDuplicidad = () => {
        
        const even = (e) => e.idDistritoJudicial === distrito && e.idMateria === materia;
        const validateAdd = rows.some( even );

        if( validateAdd ){
     
            const distritoItems = distritoArray.find( (e) => e.idDistritoJudicial === distrito );
            const materiaItems = materiaArray.find( (e) => e.idMateria === materia );

            setErrors({ add: 'El Distrito Judicial ' + distritoItems?.descripcion + ' y la Matería ' + materiaItems?.descripcion + ' ya estan agregados' });
            
            setLoadingSave( false );

            return false;
        }

        return true;
    }

    const validateFiels = () => {
        
        setErrors( { } );

        let valid = true;
        let errores = {};

        if( distrito === 0 ){
            valid = false;
            errores.distrito = 'Debes seleccionar un Distrito';
        }    
        
        if( materia === 0 ){
            valid = false;
            errores.materia = 'Debes seleccionar una Materia';
        }  

        setErrors( errores );
        return valid;
    } 

    useEffect(() => {
        
        async function Obtener(){
            
            await MateriaDistritos().then(response => { 
                
                if( response ){
                    if( response.status === 200 ){
                       
                        setTimeout(() => {
                        
                            setLoadingTable( false );
                            setRows( response.data );

                        }, 1000);

                    }
                }
                
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerDistritosJudiciales().then(response => {
                
                if( response ){
                    if( response.status === 200 ){
                        setDistritoArray( response.data );
                    }
                }
                
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){
            
            await Materias().then(response => {
                
                if( response ){
                    if( response.status === 200 ){
                        setMateriaArray( response.data );
                    }
                }
                
            });

        }

        Obtener();

    }, [ ]);

    return (
        <>
            
            <NavbarInicio />

            {
                ( !loading && tipoUsuario !== 3 )
                &&
                <NotFoundScreen />
            }

            {
                ( !loading && tipoUsuario === 3  )
                &&   
                <>

                    <Container maxWidth='xl' sx={{ mt: { md: '13em', xs: '11em' } }}>

                        <Box sx={{ pb: '2em', pl: { md: 10, xs: 1 }, pr: { md: 10, xs: 1 }, pt: 2 }} component={ Paper } >	

                            <Container maxWidth="lg">   

                                <Grid container spacing={3} sx={{ mt: 1 }} >  
                                        
                                    <Grid item md={6} xs={6} sx={{ textAlign: 'left' }}> 
                                        <Button type="button" startIcon={ <UndoIcon /> } variant='contained' color='inherit' sx={{ mt: 1 }} onClick={ () => navigate('/administracion/') }> 
                                            Regresar a los catálogos
                                        </Button> 
                                    </Grid>

                                    <Grid item md={6} xs={6} sx={{ textAlign: 'right' }}> 
                                        <Button type="button" startIcon={ <AddCircleOutlineRoundedIcon /> } variant="contained" sx={{ mt: 1 }} onClick={ AgregarRegistro }> 
                                            Agregar
                                        </Button> 
                                    </Grid>

                                </Grid>

                                <Grid container spacing={3} sx={{ mt: 1 }} >  
                                    
                                    <Grid item xs={12} md={12}> 

                                        <Toolbar sx={{ pl: { sm: 2 }, pr: { xs: 1, sm: 1 } }} >
                                            <Typography sx={{ flex: '1 1 100%' }} variant="h6" component="div" >
                                                Matería - Distrito
                                            </Typography>
                                        </Toolbar>

                                        <TableContainer>

                                            <Table sx={{ minWidth: 500 }} >
                                                <TableHead>
                                                    <TableRow>        
                                                        <TableCell style={{ width:'10%' }}> ID </TableCell>
                                                        <TableCell style={{ width:'30%' }}> MATERIA</TableCell>
                                                        <TableCell style={{ width:'30%' }}> DISTRITO </TableCell>
                                                        <TableCell style={{ width:'10%' }}> HABILITADO </TableCell>
                                                        <TableCell style={{ width:'10%' }}> EDITAR </TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                {
                                                (rowsPerPage > 0
                                                    ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    : rows
                                                ).map((row) => (
                                                    <TableRow key={ row.idMateriaDistrito} >
                                                    
                                                        <TableCell style={{ fontWeight: 'bold' }}>
                                                            { row.idMateriaDistrito }
                                                        </TableCell>

                                                        <TableCell>
                                                            { row?.materia?.descripcion }
                                                        </TableCell>

                                                        <TableCell>
                                                            { row?.distritoJudicial?.descripcion }
                                                        </TableCell>
                                                        
                                                        <TableCell>
                                                            {
                                                                row.activo 
                                                                ? 
                                                                (
                                                                    <Switch 
                                                                        inputProps={ { 'aria-label': 'Switch demo'} } 
                                                                        checked={ row.activo } 
                                                                        onChange={ ( e ) => handleChangeSwitch( row.idMateriaDistrito, e.target.checked ) }
                                                                    />
                                                                ) 
                                                                :                                           
                                                                ( 
                                                                    <Switch 
                                                                        inputProps={ { 'aria-label': 'Switch demo'} } 
                                                                        checked={ row.activo } 
                                                                        onChange={ ( e ) => handleChangeSwitch( row.idMateriaDistrito, e.target.checked ) }
                                                                    />
                                                                )
                                                            }
                                                        </TableCell>

                                                        <TableCell>
                                                            <IconButton 
                                                                    color="primary" 
                                                                    aria-label="edit" 
                                                                    component="span" 
                                                                    onClick={ () =>{ EditarRegistro( row.idMateriaDistrito,  row.distritoJudicial.idDistritoJudicial, row.materia.idMateria )}  }
                                                                >                                                        
                                                                <EditIcon />
                                                            </IconButton>  
                                                        </TableCell>

                                                    </TableRow>
                                                ))}

                                                { 
                                                    rows.length === 0 && (
                                                        <TableRow style={{ height: 53 }}>

                                                            <TableCell colSpan={10} align="center"> 
                                                                {
                                                                    loadingTable
                                                                    ?
                                                                        <CircularProgress size={40} sx={{ mt: 2, mb: 2 }} />
                                                                    :
                                                                        ''
                                                                }
                                                                {
                                                                    !loadingTable && rows.length === 0
                                                                    ?
                                                                        'No se encontraron usuarios'
                                                                    :
                                                                        ''
                                                                }
                                                            </TableCell>

                                                        </TableRow>
                                                    )
                                                }

                                                </TableBody>

                                                <TableFooter>
                                                    <TableRow>
                                                        <TablePagination
                                                            rowsPerPageOptions={[ 5, 10, 15, 20, 25, 50, 100 ]}
                                                            colSpan={6}
                                                            count={rows.length}                                        
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}                                                                                
                                                            onPageChange={ handleChangePage }
                                                            onRowsPerPageChange={ handleChangeRowsPerPage }
                                                            ActionsComponent={ TablePaginationActions }

                                                            labelRowsPerPage="Filas por página"                                            
                                                            labelDisplayedRows={
                                                                ({ from, to, count }) => {
                                                                return '' + from + '-' + to + ' de ' + count
                                                                }
                                                            }  
                                                        />
                                                    </TableRow>
                                                </TableFooter>
                                            </Table>
                                        </TableContainer>
                                
                                </Grid>

                            </Grid>

                        </Container>

                    </Box>             

                    </Container>

                    <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>       
                    
                        <DialogContent>

                            <FormControl fullWidth sx={{ mt: 3 }} >
                                <InputLabel id="select-materia-label">Materia</InputLabel>
                            
                                <Select
                                    labelId="select-materia-label"
                                    id="select-materia"                                            
                                    label="Materia"
                                    name="materia"
                                    value={ materia }                                
                                    onChange={ ( e ) => { setMateria( e.target.value ) } }
                                >
                                    <MenuItem key={0} value={0}>Seleccione una opción</MenuItem>
                                    {
                                        materiaArray.map( ( elem ) => (
                                            <MenuItem key={ elem.idMateria } value={ elem.idMateria }> { elem.descripcion } </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                            {   
                                errors.materia  && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.materia } </Alert> )
                            }

                            <FormControl fullWidth sx={{ mt: 3 }} >
                                <InputLabel id="select-distrito-label">Distrito</InputLabel>
                            
                                <Select
                                    labelId="select-distrito-label"
                                    id="select-distrito"                                            
                                    label="Distrito"
                                    name="distrito"
                                    value={ distrito }                                
                                    onChange={ ( e ) => { setDistrito( e.target.value ) } }
                                >
                                    <MenuItem key={0} value={0}>Seleccione una opción</MenuItem>
                                    {
                                        distritoArray.map( ( elem ) => (
                                            <MenuItem key={ elem.idDistritoJudicial } value={ elem.idDistritoJudicial }> { elem.descripcion }   </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                            {   
                                errors.tipoTramite  && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.tipoTramite } </Alert> )
                            }

                            {   
                                errors.add  && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.add } </Alert> )
                            }

                        </DialogContent>

                        <DialogActions>
                            <Button onClick={ handleCloseModal }> Cancelar </Button>
                            <Button onClick={ Guardar } variant='contained' startIcon={ <SaveIcon /> } > Guardar </Button>
                        </DialogActions>

                        <LinearProgress sx={{ display: loadingSave ? 'flex' : 'none' }} />

                    </Dialog>

                </>
            }

        </>
    )
}
